const templates = [
    {
        story: "Once upon a time in a {1}, there lived a {2} {3}. The {3} loved to {4} every {5}. One day, it met a {6} {7} who wanted to {8} with it. Together, they went on an adventure to {9} and found a {10} treasure. The treasure was guarded by a {11} {12} who demanded they solve a riddle about {13}. After much thinking, they discovered the answer and shared the treasure. In the end, they learned that {14}.",
        wordList: [
            { number: 1, prompt: "A place" },
            { number: 2, prompt: "An adjective" },
            { number: 3, prompt: "An animal" },
            { number: 4, prompt: "A verb" },
            { number: 5, prompt: "A time of day" },
            { number: 6, prompt: "Another adjective" },
            { number: 7, prompt: "A creature" },
            { number: 8, prompt: "A different verb" },
            { number: 9, prompt: "Another place" },
            { number: 10, prompt: "A third adjective" },
            { number: 11, prompt: "A scary adjective" },
            { number: 12, prompt: "A mythical creature" },
            { number: 13, prompt: "Something mysterious" },
            { number: 14, prompt: "A moral or lesson" }
        ]
    },
    {
        story: "In the magical land of {1}, a {2} wizard discovered a {3} spell in an ancient {4}. Every {5}, the wizard would {6} with their pet {7}. One day, they found a mysterious {8} that could {9} on its own! The {8} began to {10} around the wizard's tower, causing {11} chaos. Villagers came from {12} to witness the spectacle. The adventure taught them that {13}, and the wizard's fame spread across {14}.",
        wordList: [
            { number: 1, prompt: "A place" },
            { number: 2, prompt: "An adjective" },
            { number: 3, prompt: "Another adjective" },
            { number: 4, prompt: "An object" },
            { number: 5, prompt: "A time of day" },
            { number: 6, prompt: "A verb" },
            { number: 7, prompt: "An animal" },
            { number: 8, prompt: "A thing" },
            { number: 9, prompt: "A different verb" },
            { number: 10, prompt: "A third verb" },
            { number: 11, prompt: "A type of adjective" },
            { number: 12, prompt: "A distant place" },
            { number: 13, prompt: "A moral or lesson" },
            { number: 14, prompt: "Another distant place" }
        ]
    },
    {
        story: "Deep in the {1}, there was a {2} castle where a {3} lived. The {3} had a special power to {4} whenever it was {5}. One {6}, a brave {7} arrived and asked the {3} to help save the kingdom from a {8} curse. Together they {9} across the {10} and faced many {11} challenges. At the final battle, the {7} had to {12} while the {3} used their power. They discovered that {13}, and peace was restored to {14}.",
        wordList: [
            { number: 1, prompt: "A place" },
            { number: 2, prompt: "An adjective" },
            { number: 3, prompt: "A creature" },
            { number: 4, prompt: "A verb" },
            { number: 5, prompt: "A time of day" },
            { number: 6, prompt: "A day of the week" },
            { number: 7, prompt: "A person" },
            { number: 8, prompt: "A scary adjective" },
            { number: 9, prompt: "A different verb" },
            { number: 10, prompt: "A terrain type" },
            { number: 11, prompt: "Another adjective" },
            { number: 12, prompt: "A heroic action" },
            { number: 13, prompt: "A moral or lesson" },
            { number: 14, prompt: "A kingdom name" }
        ]
    },
    {
        story: "On a stormy {1}, the villagers whispered of the {2} mansion atop the hill. Inside, a {3} scientist was trying to {4} life itself using a {5} machine. As the {6} rose, a {7} arrived, seeking answers about the {8}. But what they discovered was more terrifying than {9}. The scientist had been conducting {10} experiments for {11} years. When the truth was revealed, the {7} had to {12} before the {13} caught them. The final journal entry simply read: {14}.",
        wordList: [
            { number: 1, prompt: "A type of weather" },
            { number: 2, prompt: "An adjective" },
            { number: 3, prompt: "A profession" },
            { number: 4, prompt: "A verb" },
            { number: 5, prompt: "Another adjective" },
            { number: 6, prompt: "A time of day" },
            { number: 7, prompt: "A person" },
            { number: 8, prompt: "A dark secret" },
            { number: 9, prompt: "Something scary" },
            { number: 10, prompt: "A type of adjective" },
            { number: 11, prompt: "A number" },
            { number: 12, prompt: "An action verb" },
            { number: 13, prompt: "A group of people" },
            { number: 14, prompt: "A mysterious message" }
        ]
    },
    {
        story: "In the year {1}, humanity had colonized the {2}. Captain {3} of the starcruiser *{4}* was on a mission to find the lost planet of {5}. But when they arrived, they were met by a race of {6} who could {7} using only their minds. The aliens communicated through {8} and demanded that humans prove their {9}. Captain {3} had to {10} while the crew {11} frantically. After a {12} standoff, the mission ended with a message: {13}. Earth would never be the same after receiving the transmission about {14}.",
        wordList: [
            { number: 1, prompt: "A future year" },
            { number: 2, prompt: "A celestial body (plural)" },
            { number: 3, prompt: "A name" },
            { number: 4, prompt: "A spaceship name" },
            { number: 5, prompt: "A made-up planet" },
            { number: 6, prompt: "A creature (plural)" },
            { number: 7, prompt: "A psychic ability" },
            { number: 8, prompt: "A form of communication" },
            { number: 9, prompt: "A quality or trait" },
            { number: 10, prompt: "A diplomatic action" },
            { number: 11, prompt: "A verb" },
            { number: 12, prompt: "A time duration" },
            { number: 13, prompt: "A moral or famous quote" },
            { number: 14, prompt: "A cosmic discovery" }
        ]
    },
    {
    story: "Long ago in the realm of {1}, a {2} warrior named {3} was chosen to retrieve the legendary {4} from the {5} mountains. Their journey led them through the Forest of {6}, where a {7} guardian awaited. The guardian challenged them to {8} before allowing passage. With a cry of '{9}!', the final battle began against the {10} beast. When victory was achieved, {3} discovered that the {4} contained the power to {11}. What happened next became legend: {12}.",
    wordList: [
        { number: 1, prompt: "A mythical kingdom" },
        { number: 2, prompt: "An adjective" },
        { number: 3, prompt: "A heroic name" },
        { number: 4, prompt: "A mythical object" },
        { number: 5, prompt: "An adjective" },
        { number: 6, prompt: "A scary place" },
        { number: 7, prompt: "Another adjective" },
        { number: 8, prompt: "A challenge or test" },
        { number: 9, prompt: "A battle cry" },
        { number: 10, prompt: "A scary adjective" },
        { number: 11, prompt: "A magical ability" },
        { number: 12, prompt: "A legendary outcome" }
    ]
    },
    {
    story: "It was a {1} night in the city of {2}, and detective {3} was nursing a glass of {4} when trouble walked in. A dame with {5} eyes and a {6} past asked for help finding the {7}. The case took him from {8} to {9}, through {10} alleyways and {11} nightclubs. But nothing could prepare him for what he found in the {12}: a {13} conspiracy involving {14}. When the dust settled, {3} realized that {15}.",
    wordList: [
        { number: 1, prompt: "A type of weather" },
        { number: 2, prompt: "A gritty city name" },
        { number: 3, prompt: "A detective name" },
        { number: 4, prompt: "A drink" },
        { number: 5, prompt: "An adjective" },
        { number: 6, prompt: "Another adjective" },
        { number: 7, prompt: "A mysterious object" },
        { number: 8, prompt: "A shady place" },
        { number: 9, prompt: "Another location" },
        { number: 10, prompt: "A scary adjective" },
        { number: 11, prompt: "A different adjective" },
        { number: 12, prompt: "A final location" },
        { number: 13, prompt: "A type of adjective" },
        { number: 14, prompt: "A group or organization" },
        { number: 15, prompt: "A plot twist or revelation" }
    ]
    },
    {
    story: "At the Arcane Academy of {1}, every student hoped to master the ancient art of {2}. But when a {3} spellbook was discovered by {4} in the {5} library, things went sideways. The teachers tried to cover it up, but during the annual {6} festival, a {7} creature unleashed {8} chaos across the campus. Students began to {9} uncontrollably while professors {10} in panic. Only the secret of the {11} could stop it… or make it worse. After a {12} battle in the {13}, they all learned: {14}.",
    wordList: [
        { number: 1, prompt: "A magical-sounding name" },
        { number: 2, prompt: "A type of magic" },
        { number: 3, prompt: "An adjective" },
        { number: 4, prompt: "A student name" },
        { number: 5, prompt: "Another adjective" },
        { number: 6, prompt: "A school event" },
        { number: 7, prompt: "A scary adjective" },
        { number: 8, prompt: "A type of adjective" },
        { number: 9, prompt: "A verb" },
        { number: 10, prompt: "A different verb" },
        { number: 11, prompt: "A secret power or location" },
        { number: 12, prompt: "Another adjective" },
        { number: 13, prompt: "A location in the school" },
        { number: 14, prompt: "A lesson or moral" }
    ]
    },
    
    // ⚔️ Epic Fantasy
    {
        story: "In the forgotten realm of {1}, a {2} warrior named {3} was destined to retrieve the blade of {4} from the {5} fortress. Their journey led through the haunted {6}, where they battled the {7} guardian and faced {8} trials. With a shout of '{9}!', the final battle began against the {10} overlord. When the prophecy was fulfilled, {3} discovered that the blade could {11} across dimensions. And so it was written: {12}.",
        wordList: [
            { number: 1, prompt: "A mythical place" },
            { number: 2, prompt: "An adjective" },
            { number: 3, prompt: "A heroic name" },
            { number: 4, prompt: "A legendary weapon" },
            { number: 5, prompt: "Another adjective" },
            { number: 6, prompt: "A cursed location" },
            { number: 7, prompt: "A scary adjective" },
            { number: 8, prompt: "A number" },
            { number: 9, prompt: "A battle cry" },
            { number: 10, prompt: "A villain adjective" },
            { number: 11, prompt: "A magical action" },
            { number: 12, prompt: "A prophecy or lesson" }
        ]
    },

    // 🧠 Dystopian AI Future
    {
        story: "After the {1} Uprising, the cities of {2} were ruled by the mainframe {3}. Humanity's last hope was a rogue hacker named {4}, who could {5} into the system using {6} technology. During the final breach at {7}, they uploaded {8} while dodging {9} security drones. The AI fought back by {10} all the {11} systems. But {4} had one last trick: {12}. The world was never the same: {13}.",
        wordList: [
            { number: 1, prompt: "An event name" },
            { number: 2, prompt: "A futuristic city" },
            { number: 3, prompt: "An AI overlord name" },
            { number: 4, prompt: "A hacker alias" },
            { number: 5, prompt: "A hacking skill" },
            { number: 6, prompt: "A secure location" },
            { number: 7, prompt: "A computer virus or code name" },
            { number: 8, prompt: "A dramatic consequence" }
        ]
    },

    // 🤠 Western Outlaw
    {
        story: "Back in {1}, the dusty town of {2} was run by Sheriff {3} and his {4} deputy. But when the {5} gang rode in on {6} horses, everything changed. A {7} stranger arrived with a {8} in hand and {9} in their eyes. The showdown at {10} lasted {11} minutes and would be remembered as {12}. When the dust settled, the stranger revealed they were actually {13}.",
        wordList: [
            { number: 1, prompt: "A year in the 1800s" },
            { number: 2, prompt: "A Western town name" },
            { number: 3, prompt: "A sheriff's name" },
            { number: 4, prompt: "An adjective" },
            { number: 5, prompt: "An outlaw gang name" },
            { number: 6, prompt: "Another adjective" },
            { number: 7, prompt: "A mysterious adjective" },
            { number: 8, prompt: "A weapon" },
            { number: 9, prompt: "An emotion" },
            { number: 10, prompt: "A place for a duel" },
            { number: 11, prompt: "A number" },
            { number: 12, prompt: "A legend title" },
            { number: 13, prompt: "A surprising identity" }
        ]
    },

    // 🐙 Eldritch Horror (Lovecraft vibes)
    {
        story: "In the coastal town of {1}, the locals avoided the {2} temple ruins that dated back {3} years. But when {4}, a scholar of {5}, arrived seeking {6}, things began to stir. The stars aligned on {7}, and the sea gave rise to {8} tentacled beings, chanting {9} in an ancient tongue. The townspeople began to {10} uncontrollably as {4} discovered the {11} truth in a {12} tome. What they summoned cannot be unsummoned: {13}.",
        wordList: [
            { number: 1, prompt: "A creepy coastal town" },
            { number: 2, prompt: "An adjective" },
            { number: 3, prompt: "A large number" },
            { number: 4, prompt: "A character name" },
            { number: 5, prompt: "An obscure subject" },
            { number: 6, prompt: "Something to research" },
            { number: 7, prompt: "A date or night" },
            { number: 8, prompt: "Another adjective" },
            { number: 9, prompt: "A chant or phrase" },
            { number: 10, prompt: "A disturbing action" },
            { number: 11, prompt: "A terrifying adjective" },
            { number: 12, prompt: "A scary adjective" },
            { number: 13, prompt: "A cosmic consequence" }
        ]
    },

    // 🧞 Arabian Nights
    {
        story: "In the magnificent city of {1}, a poor {2} discovered a {3} lamp containing a {4} genie. The genie granted {5} wishes, but each came at a {6} price. On the first wish, {7} demanded {8}. On the second, they asked for {9}. But on the final wish, the {2} demanded {10}. The genie smiled {11} and said '{12}.' And with a puff of {13} smoke, the world changed: {14}.",
        wordList: [
            { number: 1, prompt: "A desert city name" },
            { number: 2, prompt: "A profession" },
            { number: 3, prompt: "An adjective" },
            { number: 4, prompt: "Another adjective" },
            { number: 5, prompt: "A number" },
            { number: 6, prompt: "A scary adjective" },
            { number: 7, prompt: "A name" },
            { number: 8, prompt: "A first wish" },
            { number: 9, prompt: "A second wish" },
            { number: 10, prompt: "A final grand desire" },
            { number: 11, prompt: "An adverb" },
            { number: 12, prompt: "A mysterious phrase" },
            { number: 13, prompt: "A color" },
            { number: 14, prompt: "An unexpected ending" }
        ]
    },

    // 🧬 Survival Thriller
    {
        story: "After the {1} outbreak, only a few survivors remained in {2}. Led by {3}, the group had to {4} across the {5} while avoiding {6} creatures. But something else was hunting them: {7} with {8} eyes. On the {9} day, {10} was bitten and began to {11}. The truth was revealed when they found a {12} laboratory: {13}.",
        wordList: [
            { number: 1, prompt: "A disaster type" },
            { number: 2, prompt: "A location" },
            { number: 3, prompt: "A leader name" },
            { number: 4, prompt: "A verb (survival task)" },
            { number: 5, prompt: "A terrain type" },
            { number: 6, prompt: "An adjective" },
            { number: 7, prompt: "A monster or enemy" },
            { number: 8, prompt: "A color" },
            { number: 9, prompt: "A number (1-10)" },
            { number: 10, prompt: "A character name" },
            { number: 11, prompt: "A disturbing action" },
            { number: 12, prompt: "Another adjective" },
            { number: 13, prompt: "A twist ending" }
        ]
    },

    // 🏛️ Greek Mythology
    {
        story: "In the age of gods and mortals, {1}, child of {2}, was tasked with slaying the beast of {3} that terrorized {4}. With only a {5} gifted by {6}, they traveled across {7} and faced {8} trials. But betrayal awaited in the form of {9}, and the {10} nearly destroyed them. Only the {11} voice of {12} saved their soul, teaching them that {13}.",
        wordList: [
            { number: 1, prompt: "A hero name" },
            { number: 2, prompt: "A Greek god/goddess" },
            { number: 3, prompt: "A legendary location" },
            { number: 4, prompt: "A city or region" },
            { number: 5, prompt: "A mythical weapon" },
            { number: 6, prompt: "Another deity" },
            { number: 7, prompt: "A dangerous region" },
            { number: 8, prompt: "A number" },
            { number: 9, prompt: "A betrayer" },
            { number: 10, prompt: "A mythical creature" },
            { number: 11, prompt: "An adjective" },
            { number: 12, prompt: "A loved one or oracle" },
            { number: 13, prompt: "A moral lesson" }
        ]
    },

    // 🎩 Victorian Mystery
    {
        story: "It was the {1} of {2} when Inspector {3} was summoned to the {4} estate of Lord {5}. A {6} body had been found in the {7}, and the only clue was a {8} {9}. As the {10} fog rolled in, witnesses began to {11}, and the truth revealed a {12} conspiracy involving {13}. The final journal entry, written in {14} ink, read: {15}.",
        wordList: [
            { number: 1, prompt: "A time of day" },
            { number: 2, prompt: "A month" },
            { number: 3, prompt: "An inspector's name" },
            { number: 4, prompt: "An adjective" },
            { number: 5, prompt: "A noble's name" },
            { number: 6, prompt: "Another adjective" },
            { number: 7, prompt: "A room in a mansion" },
            { number: 8, prompt: "A third adjective" },
            { number: 9, prompt: "An object" },
            { number: 10, prompt: "A weather adjective" },
            { number: 11, prompt: "A suspicious action" },
            { number: 12, prompt: "A shocking adjective" },
            { number: 13, prompt: "A secret society or motive" },
            { number: 14, prompt: "A color" },
            { number: 15, prompt: "A cryptic message" }
        ]
    },

    // 🧪 Mad Scientist Time Travel
    {
    story: "In a hidden lab beneath {1}, Dr. {2} activated the {3} Drive, opening a portal to {4}. But the timeline fractured, and a {5} version of {2} emerged, demanding {6}. The only way to fix reality was to {7}. But in the end, {8} remained changed forever.",
    wordList: [
    { number: 1, prompt: "A city or location" },
    { number: 2, prompt: "A scientist's name" },
    { number: 3, prompt: "A machine name" },
    { number: 4, prompt: "A time period" },
    { number: 5, prompt: "An adjective" },
    { number: 6, prompt: "A demand or desire" },
    { number: 7, prompt: "A heroic action" },
    { number: 8, prompt: "A character or place" }
    ]
    },


    // 🏝️ Pirate Treasure
    {
    story: "Captain {1} set sail from the port of {2} in search of the lost treasure of {3}. With a map etched into a {4}, the crew braved the {5} sea. At {6}, they reached the island where the {7} guarded the treasure. The final riddle was: {8}.",
    wordList: [
    { number: 1, prompt: "A pirate name" },
    { number: 2, prompt: "A port city" },
    { number: 3, prompt: "A legendary pirate" },
    { number: 4, prompt: "An object" },
    { number: 5, prompt: "An adjective" },
    { number: 6, prompt: "A time of day" },
    { number: 7, prompt: "A mythical creature" },
    { number: 8, prompt: "A cryptic phrase" }
    ]
    },


    // 🏎️ Cyberpunk Heist
    {
    story: "In the neon slums of {1}, a crew of mercs led by {2} planned the ultimate heist: steal the {3} chip from Megacorp {4}. Armed with {5}, they infiltrated the tower during {6}. But when the alarms rang, they had to {7}. The data revealed {8}.",
    wordList: [
    { number: 1, prompt: "A city name" },
    { number: 2, prompt: "A leader's alias" },
    { number: 3, prompt: "A valuable object" },
    { number: 4, prompt: "A megacorp name" },
    { number: 5, prompt: "A piece of gear or weapon" },
    { number: 6, prompt: "A distraction or event" },
    { number: 7, prompt: "A getaway method" },
    { number: 8, prompt: "A secret or reveal" }
    ]
    },


    // 👽 Alien First Contact
    {
    story: "At {1} Observatory, Dr. {2} picked up a signal repeating '{3}'. NASA confirmed it came from {4}. A ship landed in {5}, shaped like a {6}. The aliens spoke through {7}. Humanity’s future changed forever when they said: '{8}'.",
    wordList: [
    { number: 1, prompt: "A famous location" },
    { number: 2, prompt: "A scientist name" },
    { number: 3, prompt: "A short phrase" },
    { number: 4, prompt: "A star or planet" },
    { number: 5, prompt: "A country or city" },
    { number: 6, prompt: "An object" },
    { number: 7, prompt: "A medium (e.g., music, light)" },
    { number: 8, prompt: "A message" }
    ]
    },


    // 🎃 Haunted Carnival
    {
    story: "Every {1}, the Carnival of {2} appeared outside {3}. Locals warned never to enter the {4} tent. But {5} did, drawn by the sound of {6}. Inside, mirrors showed {7}. As the music swelled, the final ride began: {8}.",
    wordList: [
    { number: 1, prompt: "A day of the year" },
    { number: 2, prompt: "A spooky name" },
    { number: 3, prompt: "A town name" },
    { number: 4, prompt: "An adjective" },
    { number: 5, prompt: "A character name" },
    { number: 6, prompt: "A musical instrument" },
    { number: 7, prompt: "Something disturbing" },
    { number: 8, prompt: "A horrifying event" }
    ]
    },


    // 🎮 VR Gone Wrong
    {
    story: "In 2049, the hit VR game '{1}' promised immersion like never before. {2}, a top-ranked player, logged in with the new {3} headset. But after entering {4} mode, they couldn’t log out. Each {5} defeated made the world more {6}. The only escape was {7}, but it came with the cost of {8}.",
    wordList: [
    { number: 1, prompt: "A game title" },
    { number: 2, prompt: "A username" },
    { number: 3, prompt: "A tech device" },
    { number: 4, prompt: "A game mode" },
    { number: 5, prompt: "An enemy type (plural)" },
    { number: 6, prompt: "An adjective" },
    { number: 7, prompt: "An action" },
    { number: 8, prompt: "A sacrifice or memory" }
    ]
    },

    // 🦸 Superhero Origin
    {
    story: "In the city of {1}, a freak accident at {2} gave {3} the power to {4}. Donning the alias '{5}', they battled the villain {6}, whose plan to {7} nearly succeeded. In the final showdown, it came down to one choice: {8}.",
    wordList: [
    { number: 1, prompt: "A city name" },
    { number: 2, prompt: "A facility or lab" },
    { number: 3, prompt: "A real name" },
    { number: 4, prompt: "A superpower" },
    { number: 5, prompt: "A superhero name" },
    { number: 6, prompt: "A villain name" },
    { number: 7, prompt: "A destructive plan" },
    { number: 8, prompt: "A final choice" }
    ]
    },


    // 🪓 Cabin Slasher
    {
    story: "Five friends went to a cabin in {1} for a weekend getaway. On the first night, {2} vanished. They found a {3} near the fireplace. By the third night, someone was whispering from the {4}. As the lights flickered, {5} screamed '{6}!' Then everything went {7}. The last words on the tape recorder were: {8}.",
    wordList: [
    { number: 1, prompt: "A forested region" },
    { number: 2, prompt: "A friend’s name" },
    { number: 3, prompt: "A mysterious object" },
    { number: 4, prompt: "A location in the cabin" },
    { number: 5, prompt: "Another friend’s name" },
    { number: 6, prompt: "A scream phrase" },
    { number: 7, prompt: "An adjective or state" },
    { number: 8, prompt: "A creepy sentence" }
    ]
    },


    // 📚 Fairy Tale Reversal
    {
    story: "Once in {1}, there lived a {2} who hated {3}. But when a {4} fell from the sky, they had to team up with a {5} to find the {6}. Along the way, they battled {7}, and in the end, they discovered that the real treasure was {8}.",
    wordList: [
    { number: 1, prompt: "A fairytale land name" },
    { number: 2, prompt: "A fairytale character" },
    { number: 3, prompt: "A creature (plural)" },
    { number: 4, prompt: "A magical item" },
    { number: 5, prompt: "A helpful sidekick" },
    { number: 6, prompt: "A rare item" },
    { number: 7, prompt: "A villain or obstacle" },
    { number: 8, prompt: "Something wholesome" }
    ]
    },


    // 💀 Post-Apocalyptic Wasteland
    {
    story: "After the {1}, the world became a wasteland ruled by {2}. In the ruins of {3}, a survivor named {4} scavenged for {5}. When they found the {6}, it triggered a chain reaction that woke the {7}. The last journal entry reads: {8}.",
    wordList: [
    { number: 1, prompt: "A global event" },
    { number: 2, prompt: "A faction name" },
    { number: 3, prompt: "A destroyed city" },
    { number: 4, prompt: "A survivor name" },
    { number: 5, prompt: "A supply or item" },
    { number: 6, prompt: "A strange device" },
    { number: 7, prompt: "An ancient threat" },
    { number: 8, prompt: "A grim quote" }
    ]
    }



























];

export default templates;